import { handleSettledPromises } from '@kk/shared/utils/async';
// import { removeSearchParams } from '@kk/shared/utils/strings';
import { hasNoErrors } from '@kk/shared/utils/type-guards';
import { assertParamsPrescence } from '@kk/shared/utils/validators';
import { useParams, useRouteLoaderData } from 'react-router';
// import { fetchLoanPortfolioQuery } from '@/api/hooks/useLoanPortfolio';
import type { LeasingPortfolioInfoResponse } from '../TEMPORARY_TYPES';

export type LoaderData = Awaited<ReturnType<typeof loader>>;

export type Params = {
  companyId?: string;
};

export const id = 'delivery-approvals-page' as const;

// const removeQueryStringFromParams = (params: Params) => {
//   return Object.keys(params).reduce((acc, key) => {
//     return {
//       ...acc,
//       [key]: removeSearchParams(params[key]),
//     };
//   }, {} as Params);
// };

async function loader({ params }: { params: Params }) {
  assertParamsPrescence(params);
  // let { companyId } = removeQueryStringFromParams(params);
  // companyId = '1';
  const data = await handleSettledPromises([
    // fetchLoanPortfolioQuery({ companyId }),
    // fetchLoanPortfolioQuery({ companyId }),
  ]);
  if (!hasNoErrors(data)) throw new Error(`Failed to load ${id} data`);

  //const [leasingPortfolio] = data;

  const deliveryApprovalsPortfolio: LeasingPortfolioInfoResponse = {};

  return {
    deliveryApprovalsPortfolio,
  };
}

export const useDeliveryApprovalsPageLoaderData = () =>
  useRouteLoaderData(id) as LoaderData;

export const useDeliveryApprovalsPageParams = () => useParams<Params>();

export default loader;
